import { FunctionComponent, PropsWithChildren } from 'react';
import { Stack, Typography } from '@mui/material';

export const IntroText: FunctionComponent<PropsWithChildren<unknown>> = () => {
    return (
        <Stack spacing={3}>
            <Typography>
                Rabattierte Tickets (Spezialtarife) lassen sich im Webshop nur
                für bestimmte Gästegruppen sichtbar und buchbar machen.
            </Typography>

            <ul>
                <li>
                    <Typography>
                        z.B. Saisonkarten für Skilehrer, „Einheimischentarife“,
                        rabattierte Tickets für Behinderte, Bonus für
                        Stammkunden, usw.
                    </Typography>
                </li>
                <li>
                    <Typography>
                        Nur Gäste, die einen Freigabecode für dieses rabattierte
                        Ticket erhalten und diesen Code auf ihrer Keycard
                        registrieren, können das Ticket online sehen und buchen.
                        Und das so lange, bis das rabattierte Ticketangebot
                        wieder aus dem Onlineverkauf genommen wird.
                    </Typography>
                </li>
            </ul>

            <Typography variant='h6'>Ablauf</Typography>

            <ol>
                <li>
                    <Typography>
                        Hier eine Freigabegruppe mit der gewünschten Anzahl an
                        Freigabecodes für die Gäste anlegen. Unser Tipp: einen
                        einfachen Gruppennamen wählen.
                    </Typography>
                </li>

                <li>
                    <Typography>
                        Danach über SKIDATA oder AXESS ein rabattiertes
                        Ticketangebot im Webshop einstellen. Wichtig: eine
                        eindeutige Ticketbeschreibung im Internettextfeld
                        wählen, die sich von allen anderen Tickets
                        unterscheidet! (Die Beschreibung kann später von
                        starjack geändert werden.) Dies ist grundlegend für den
                        nächsten Schritt:
                    </Typography>
                </li>

                <li>
                    <Typography>
                        Den Namen der Freigabegruppe notieren und zum Menü
                        „Produktkonfiguration“ wechseln (hier im Adminbereich).
                        Über „bearbeiten“ die Konfiguration des rabattierten
                        Tickets öffnen. Im Feld „Freigabegruppen hinterlegen“
                        den Namen der zuvor angelegten Freigabegruppe eintragen.
                        Das sperrt die Sichtbarkeit des Angebotes im Webshop und
                        verknüpft die Freigabecodes mit dem Sonderangebot.{' '}
                        <br />
                        Die Anzahl der Freigabe-Codes lässt sich hier auch im
                        Nachhinein noch erhöhen, falls weitere Codes benötigt
                        werden.
                    </Typography>
                </li>

                <li>
                    <Typography>
                        Die Freigabecodes an die Gäste ausgeben. Nur Gäste, die
                        einen Code dieser Freigabegruppe erhalten, können dieses
                        rabattierte Ticket im Webshop einsehen und buchen. Und
                        zwar so lange, wie das Ticketangebot zum Kauf angeboten
                        wird.
                    </Typography>
                </li>
            </ol>

            <Typography
                sx={{
                    fontWeight: 600,
                }}
                gutterBottom
            >
                Der Gast registriert über sein Webshop-Konto den Freigabecode
                auf einer Keycard. Nur mit dieser Keycard kann der Spezialtarif
                gebucht werden. (keine andere Buchungsoption möglich)
            </Typography>

            <Typography
                sx={{
                    fontWeight: 600,
                }}
                gutterBottom
            >
                Auch wenn der Gast mehrere Keycards in seinem Webshop-Konto hat,
                kann der Spezialtarif nur auf die Keycard(s) gebucht werden, die
                mit einem Freigabecode dafür aktiviert sind.
            </Typography>

            <Typography
                sx={{
                    textAlign: 'center',
                }}
            >
                Mit einem Freigabe-Code lässt sich die Sichtbarkeit /
                Funktionalität über den eigenen starjack-Useraccount testen.
            </Typography>
        </Stack>
    );
};
